var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgArrowUpRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3211 11.886C13.3211 12.1622 13.545 12.3861 13.8211 12.3861C14.0973 12.3861 14.3211 12.1622 14.3211 11.8861L14.3211 6.58275L14.3211 6.08275L13.8211 6.08275L8.51782 6.08275C8.24168 6.08275 8.01782 6.30661 8.01782 6.58275C8.01782 6.85889 8.24168 7.08275 8.51782 7.08275L12.3489 7.08275L5.73354 13.6981C5.53828 13.8933 5.53828 14.2099 5.73354 14.4052C5.9288 14.6004 6.24539 14.6004 6.44065 14.4052L13.3211 7.52469L13.3211 11.886Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUpRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-up-right.5ab346e2fac6520b3e5a8b56ca56a115.svg";